module.exports = __webpack_public_path__ + "static/img/food_menu_pizza.4b2b071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/food_menu_pizza.png
// module id = FQwL
// module chunks = 0